"use client";
import { FC } from "react";
import { useIntl } from "react-intl";
import clsx from "clsx";
import { SolutionItem } from "./SolutionsItem";

const Solutions: FC = () => {
  const intl = useIntl();

  const items = [
    {
      title: intl.formatMessage({ id: "SOLUTION.HEADER1" }),
      description: intl.formatMessage({ id: "SOLUTION.DESCRIPTION1" }),
    },
    {
      title: intl.formatMessage({ id: "SOLUTION.HEADER2" }),
      description: intl.formatMessage({ id: "SOLUTION.DESCRIPTION2" }),
    },
    {
      title: intl.formatMessage({ id: "SOLUTION.HEADER3" }),
      description: intl.formatMessage({ id: "SOLUTION.DESCRIPTION3" }),
    },
    {
      title: intl.formatMessage({ id: "SOLUTION.HEADER4" }),
      description: intl.formatMessage({ id: "SOLUTION.DESCRIPTION4" }),
    },
    {
      title: intl.formatMessage({ id: "SOLUTION.HEADER5" }),
      description: intl.formatMessage({ id: "SOLUTION.DESCRIPTION5" }),
    },
    {
      title: intl.formatMessage({ id: "SOLUTION.HEADER6" }),
      description: intl.formatMessage({ id: "SOLUTION.DESCRIPTION6" }),
    },
    {
      title: intl.formatMessage({ id: "SOLUTION.HEADER7" }),
      description: intl.formatMessage({ id: "SOLUTION.DESCRIPTION7" }),
    },
    {
      title: intl.formatMessage({ id: "SOLUTION.HEADER8" }),
      description: intl.formatMessage({ id: "SOLUTION.DESCRIPTION8" }),
    },
    {
      title: intl.formatMessage({ id: "SOLUTION.HEADER9" }),
      description: intl.formatMessage({ id: "SOLUTION.DESCRIPTION9" }),
    },
    {
      title: intl.formatMessage({ id: "SOLUTION.HEADER10" }),
      description: intl.formatMessage({ id: "SOLUTION.DESCRIPTION10" }),
    },
  ];

  return (
    <div className="p-5 px-4 px-md-5 mx-lg-5 bg-solutions pb-0" id="solutions">
      <h1
        className="fw-bold text-black"
        dangerouslySetInnerHTML={{
          __html: intl.formatMessage({ id: "SOLUTION.TITLE" }),
        }}
      ></h1>
      <div className="d-flex justify-content-center">
        <div className={clsx("row pt-5 w-100")}>
          {items.map((solution, index) => (
            <SolutionItem
              key={index}
              id={index + 1}
              title={solution.title}
              description={solution.description}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export { Solutions };
